var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiwSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.964,
    height: 98.695,
    viewBox: "0 0 105.964 98.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_117",
    "data-name": "Gruppe 117",
    transform: "translate(-372.158 -2281.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_109",
    "data-name": "Gruppe 109",
    transform: "translate(13.158 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_82",
    "data-name": "Gruppe 82",
    transform: "translate(360 2289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_38",
    "data-name": "Gruppe 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_97",
    "data-name": "Pfad 97",
    d: "M306.909,18.1a1.7,1.7,0,0,0-2.3.728l-6.522,12.588H237.91a33.922,33.922,0,1,0,0,67.845h25.027l-6.653,12.843a1.705,1.705,0,0,0,3.028,1.571l7.469-14.414,35.151-67.845L307.638,20.4A1.706,1.706,0,0,0,306.909,18.1ZM264.7,95.854H237.91a30.514,30.514,0,0,1,0-61.028h58.413Z",
    transform: "translate(-203.987 -17.91)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_124",
    "data-name": "Pfad 124",
    d: "M-13668.426-14177.906l20.7-2.648,24.017.807,26.508-.807-7.146,18.927-13.391,24.89-12.4,21.412h-10.045l-22.147-1.674-12.986-6.134-10.575-12.617-3.988-13.427,2.381-10.913,7.512-11.571Z",
    transform: "translate(14051 16485)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_110",
    "data-name": "Gruppe 110",
    transform: "translate(-592.158 1637.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_107",
    "data-name": "Pfad 107",
    d: "M1025.966,711.523l-13.274-13.275a15.592,15.592,0,1,0-2.443,2.443l13.275,13.273a1.727,1.727,0,1,0,2.443-2.442Zm-25.414-10.874a12.1,12.1,0,1,1,12.1-12.1A12.11,12.11,0,0,1,1000.552,700.648Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiwSearch);
export default __webpack_public_path__ + "static/media/hiw_search.8e4b786b.svg";
export { ForwardRef as ReactComponent };